import * as actionTypes from "../constants";
import * as apis from "../requests/apis";
import * as payloads from "../requests/payloads";
import * as services from "../services";
import { clientRequest, contentHeader } from "../requests";
import { showToast, TOAST_TYPE } from "utils/toast";

// Behavioural is a single per-day record per user (sleep/food/mood/activity
// scores) — upserted in place, not a list you add entries to.

// Get today's Behavioural record, if one already exists
export const getBehavioural = () => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.FETCH_BEHAVIOURALS });

    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);

    const res = await clientRequest(
      actionTypes.POST,
      apis.GET_BEHAVIOURALS_API,
      {
        userId: services.getUser(),
        fromDate: todayStart.toISOString(),
        toDate: todayEnd.toISOString(),
      },
      contentHeader
    );

    const records = Array.isArray(res.data) ? res.data : [];
    dispatch({
      type: actionTypes.GET_BEHAVIOURALS_SUCCESS,
      payload: { record: records[0] || null },
    });
  } catch (err) {
    dispatch({
      type: actionTypes.GET_BEHAVIOURALS_FAIL,
      payload: err,
    });
  }
};

// Save today's Behavioural record — creates it the first time, updates it
// on every save after that (same endpoint handles both via the record id).
export const saveBehavioural = (form) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SAVING_BEHAVIOURAL });
    const payload = payloads.behaviouralPayload(form);
    const res = await clientRequest(actionTypes.POST, apis.ADD_BEHAVIOURAL_API, payload, contentHeader);
    dispatch({
      type: actionTypes.ADD_BEHAVIOURAL_SUCCESS,
      payload: res.data || payload,
    });
    showToast("Behavioural record saved.", TOAST_TYPE.success);
  } catch (err) {
    showToast(err?.response?.data || "Failed to save behavioural record.", TOAST_TYPE.error);
    dispatch({
      type: actionTypes.ADD_BEHAVIOURAL_FAIL,
      payload: err,
    });
  }
};

// Get Advance Search (admin-only — searching other users' behavioural data)
export const getAdvanceSearchBehavioural = (username) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.ADVANCE_SEARCH_REQUEST_BEHAVIOURAL });
    const res = await clientRequest(actionTypes.GET, `${apis.GET_ADVANCE_SEARCH_API}?username=${username}&searchType=behavioural`);
    dispatch({
      type: actionTypes.GET_ADVANCE_SEARCH_BEHAVIOURAL_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({ type: actionTypes.GET_ADVANCE_SEARCH_BEHAVIOURAL_FAIL, payload: err });
  }
};

// Clear admin search results (client-side only, no request)
export const resetBehaviouralSearch = () => (dispatch) => {
  dispatch({ type: actionTypes.GET_ADVANCE_SEARCH_BEHAVIOURAL_SUCCESS, payload: [] });
};
